import HeartIcon from "@components/icons/heart-icon";
import { useRecipeWishlistStore, useWishlistRecipe } from "@features/recipe/favourite/recipe-wishlist-store";
import { useAuth } from "@provider/context-auth";
import type { Recipe } from "@type/recipe";
import type { DripsyColor } from "@utils";
import { useResponsiveValue, useSx, View } from "dripsy";
import AnimatedPressable from "@components/animated-pressable";
import * as React from "react";

function RecipeFavouriteModalButton({
  recipe,
  color = "$background",
}: {
  recipe: Recipe | undefined;
  color?: DripsyColor;
}) {
  const sx = useSx();

  const { profile } = useAuth();
  const addOrRemove = useRecipeWishlistStore((state) => state.addOrRemove);
  const isInWishlist = useWishlistRecipe({ recipeId: recipe?.id });

  const iconSize = useResponsiveValue([20, 25]);

  return (
    <View sx={{ width: 36 }}>
      <AnimatedPressable
        disabled={!recipe}
        hitSlop={{ top: 10, right: 10, bottom: 10, left: 10 }}
        style={sx({
          borderRadius: 100,
          width: 36,
          height: 36,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-around",
        })}
        onPress={() => {
          if (!recipe) {
            return;
          }
          addOrRemove({ recipe, userId: profile?.id ?? -1 });
        }}
        animate={React.useMemo(
          () =>
            ({ hovered, pressed }) => {
              return {
                transform: [{ scale: hovered || pressed ? 1.1 : 1 }],
              };
            },
          []
        )}
      >
        <HeartIcon color={color} size={iconSize} isSelected={!!isInWishlist} hasStroke />
      </AnimatedPressable>
    </View>
  );
}

export default RecipeFavouriteModalButton;
